import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as yup from "yup";
import Toggle from 'react-toggle';
import './toggle-css.css';
import getSymbolFromCurrency from 'currency-symbol-map';
import {useSelector,useDispatch} from 'react-redux';
import { Row, Form as FormBS } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import {
  chargeCalculation,
  editDiscount,
  fetchBookingById,
  fetchFeesTaxesById,
  fetchDiscountByBooking,
} from '../../../../../../../general_redux/calendar/actions';
import Loading from "../../../../../../../components/loading";
import info_icon from '../../../../../../../icons/info_icon_squared.svg';
import styles from './Payment.module.css';


const Payment = ({bookingId}) => {

  const dispatch = useDispatch();
  
  const bookingDiscount=useSelector(({calendar})=>calendar && calendar.bookingDiscount);
  const bookingData= useSelector(({calendar}) => calendar &&
  calendar.allBooking.filter((row)=>row.id===bookingId)[0]);
  const channelBookingDetails = useSelector(({ calendar }) => calendar && calendar.channelBookingDetailsByBookingId);
  const channelBookingAddonList = useSelector(({ calendar }) => calendar && calendar.channelBookingDetailsByBookingId?.addons || []);
  const feeItems = useSelector(({ calendar }) => calendar && calendar.bookingFeesTaxes?.fee || []);
  const taxItems = useSelector(({ calendar }) => calendar && calendar.bookingFeesTaxes?.tax || []).filter(item => item.type === "tax");
  const otherTaxItems = useSelector(({ calendar }) => calendar && calendar.bookingFeesTaxes?.tax || []).filter(item => item.type === "otherTaxes");
  const isChannelBooking = bookingData?.bookingType === 'channelBooking';
  const rentalDetail = useSelector(({rentals})=>rentals
      && rentals.rentals.filter((row)=>row.id===bookingData.rentalId)[0]);
  const currentCharges=useSelector(({calendar})=>calendar && calendar.currentCharges);
  const [newTotal, setNewTotal] = useState(bookingDiscount && bookingDiscount.totalPrice || 0.0);
  const [ mapForPriceMode ] = useState({
    "per stay": "Per stay",
    "per night": "Per night",
    "per person": "Per person",
    "pppn": "Per person per night",
  });
  const [discount,setDiscount]=useState({
    name: bookingDiscount && bookingDiscount.discountName || 'Discount',
    amount: bookingDiscount && bookingDiscount.discountAmount || '',
  });
  const [charges,setCharges]=useState({
    name: bookingDiscount && bookingDiscount.chargeName || 'Extra charge',
    amount: bookingDiscount && bookingDiscount.chargeAmount || '',
  });
  const [editableMode,setEditableMode]=useState(isChannelBooking || (bookingData && bookingDiscount && bookingData.price!==bookingDiscount.totalPrice));
  const [overWrittenTotal,setOverWrite]=useState(bookingData && bookingData.price || 0.0);
  const loadBookingStatus=useSelector(({calendar})=>calendar && calendar.actionForBooking)
  const [fee,setFee]=useState(bookingDiscount && bookingDiscount.fee || 0.0);
  const [tax,setTax]=useState(bookingDiscount && bookingDiscount.tax || 0.0);
  const [extraGuestFee,setExtraGuestFee]=useState(bookingDiscount && bookingDiscount.extraGuestFee || 0.0);
  const [baseRate,setBaseRate]=useState(bookingDiscount && bookingDiscount.baseRate || 0.0);
  const [errorDisc,setErrorDisc]=useState(null);
  const [togglePaymentDropdown, setTogglePaymentDropdown] = useState(false);

  useEffect(()=>{
    dispatch(fetchDiscountByBooking(bookingId));
    dispatch(fetchBookingById(bookingId));
    dispatch(fetchFeesTaxesById(bookingId));
  },[])

  useEffect(()=>{

    // TODO: use lib decimal.js or big.js for monetary calculations
    setNewTotal(baseRate+extraGuestFee-Number(discount.amount)+Number(charges.amount)+fee+tax);

  },[discount.amount,charges.amount])

  useEffect(()=>{

    if(currentCharges && currentCharges.total){
      if(currentCharges.total<0){
        setErrorDisc("Please enter valid discount amount!");
      }else{
        setErrorDisc(null);
      }

      setNewTotal(currentCharges.total);
      setOverWrite(bookingData.price);
      setTax(currentCharges.taxes);
      setFee(currentCharges.fees);
      setBaseRate(currentCharges.daily_rate);
      setExtraGuestFee(currentCharges.extra_guest_fees);

    };

  },[currentCharges])

  useEffect(()=>{
    if(bookingDiscount){
      setDiscount({
        name:bookingDiscount.discountName,
        amount:bookingDiscount.discountAmount,
      })
      setCharges({
        name:bookingDiscount.chargeName,
        amount:bookingDiscount.chargeAmount,
      })
      setFee(bookingDiscount.fee)
      setTax(bookingDiscount.tax)
      setBaseRate(bookingDiscount.baseRate)
      setExtraGuestFee(bookingDiscount.extraGuestFee)
      setNewTotal(bookingDiscount.totalPrice)
    }
  },[bookingDiscount])

  useEffect(()=>{
    if(bookingData && bookingDiscount){
      setEditableMode(bookingData.price!==bookingDiscount.totalPrice)
    }
  },[bookingData, bookingDiscount])
  
  useEffect(()=> {
    setOverWrite(bookingData?.price || 0);
  }, [editableMode])

  const handleSubmit = () => {

    const discountId = bookingDiscount.id;
    const isOWTotal = (editableMode && newTotal !== overWrittenTotal);

    const chargePayload = {
        arrive:bookingData.arrive,
        depart:bookingData.depart,
        noOfAdults: Number(bookingData.noOfAdults),
        noOfChildren: Number(bookingData.noOfChildren),
        rentalId:bookingData.rentalId,
        extraCharge:Number(charges.amount),
        discount:Number(discount.amount),
        bookingType: bookingData.bookingType,
    };

    dispatch(chargeCalculation(chargePayload)).then((res) => {
        const chargesData = res?.data?.charges;

        if (isOWTotal) {
            setEditableMode(true);
            setOverWrite(overWrittenTotal);
        };

        const payload = {
            bookingId: bookingId,
            rentalId: bookingData.rentalId,
            bookingType: bookingData.bookingType,
            discountName: discount?.name || "Discount",
            discountAmount: Number(discount.amount),
            chargeName: charges?.name || "Extra charge",
            chargeAmount: Number(charges.amount),
            tax: Number(chargesData?.taxes),
            fees: Number(chargesData?.fees),
            extraGuestFee: Number(chargesData?.extra_guest_fees),
            baseRate: Number(chargesData?.daily_rate),
            totalPrice: Number(isOWTotal ? bookingDiscount.totalPrice : newTotal),
            bookingPrice: Number(isOWTotal ? overWrittenTotal : newTotal),
            nights: Number(bookingData.nights),
            noOfAdults: Number(bookingData.noOfAdults),
            noOfChildren: Number(bookingData.noOfChildren),
        };

        dispatch(editDiscount(payload, discountId));
    });
    
  };
  
  const getCheckboxValue = (value) => {
    let checkboxValue;
    if (editableMode) {
        checkboxValue = false;
        // toast.warning("");
    } else {
        checkboxValue = !value;
    }
    return checkboxValue;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    const newValue = value;

    if (name === 'discount') {
      setDiscount({ ...discount, amount: newValue });
    } else if (name === 'charges') {
      setCharges({ ...charges, amount: newValue });
    } else if (name === 'overWrittenTotal') {
      setOverWrite(value);
    }
  };

  const initialValues = {
    discountName: discount.name,
    discountAmount: discount.amount,
    discountCheckbox: Number(discount.amount) > 0 ? true : false,
    chargeName: charges.name,
    chargeAmount: charges.amount,
    chargetCheckbox: Number(charges.amount) > 0 ? true : false,
    overWrittenTotal: editableMode ? overWrittenTotal : newTotal,
  };

  const validationSchema = yup.object().shape({
    discountName: yup.string().max(50, 'Must be 50 characters or less'),
    discountAmount: yup.number().min(0, 'Must be a number greater than or equal to 0').typeError('Must be a value of type number'),
    chargeName: yup.string().max(50, 'Must be 50 characters or less'),
    chargeAmount: yup.number().min(0, 'Must be a number greater than or equal to 0').typeError('Must be a value of type number'),
    overWrittenTotal: yup.number().min(0, 'Must be a number greater than or equal to 0').typeError('Must be a value of type number').test('overWrittenTotal',
      (overWrittenTotal === '' ? 'Must be a value other than empty' : 'Must be a different value than the current total'),
      function (value) {

        // Must be a different value than the current total
        if (editableMode && (Number(value) === Number(newTotal))) {
          return false;
        };
        
        // Must be a value other than empty
        if (value != 0 && !value) {
          return false;
        };

        return true;
      }),
  });

  
  return (
    <div className="p-3">
      <Loading loadingStatus={loadBookingStatus.loading}/>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        validateOnChange={false}
        validateOnBlur={false}
      >
      {({ values, errors, setFieldValue, handleSubmit, resetForm }) => (
      <Form onSubmit={handleSubmit} autoComplete="off">
      <>
          {['weekly', 'monthly'].includes(bookingData?.bookingType) && (
            <div className="mb-3 d-flex align-content-center">
                <div className={styles.warningIconContainer}>
                    <img src={info_icon} alt="Info Icon Squared" className={styles.warningIconOne} />
                </div>
                <div>
                    {`This is a fixed-term reservation. ${bookingData?.bookingType === 'weekly' ? 'Weekly' : 'Monthly'} pricing is being used.`}
                </div>
            </div>
          )}
          {bookingData?.bookingType === "channelBooking" && (
          <div className="mb-3 d-flex align-content-center">
            <div className={styles.warningIconContainer}>
                <img src={info_icon} alt="Info Icon Squared" className={styles.warningIconOne} />
            </div>
            <div>
                This is a channel reservation. Total due may differ from OTA host payout.
                <InfoOutlinedIcon
                    fontSize="small"
                    color="inherit"
                    data-tip
                    data-for="fixedTerm"
                    className={styles.toolTipIcon}
                    style={{marginTop: "-12px"}}
                />
                <ReactTooltip place="bottom" type="dark" id="fixedTerm" effect="solid" className={styles.toolTip}>
                    <p>
                    Each OTA sends the total amount in a different format. The "Total Due" may represent either the net amount to be deposited to the host or the total amount paid by the guest, depending on the OTA.
                    </p>
                    <p>Please refer to the price breakdown for more details.</p>
                </ReactTooltip>
            </div>
          </div>
          )}
          <div className={`d-flex`}>
            <div className={styles.subHeader}>Total due: </div>
            <div className={styles.toolTipIconContainer}>
              <InfoOutlinedIcon
                fontSize="small"
                color="inherit"
                data-tip
                data-for="totalDue"
                className={styles.toolTipIcon}
              />
              <ReactTooltip
                place="bottom"
                type="dark"
                id="totalDue"
                effect="solid"
                className={styles.toolTip}
              >
                <span>
                  In direct bookings, this is the total amount owed by the guest. <br/>
                  In channel bookings, it may represent either the guest's total payment or the host's payout, depending on the OTA. <br/>
                  For multi-rental reservations, this reflects the total for this specific rental only, not the entire group.
                </span>
              </ReactTooltip>
            </div>
            <p className={`ml-2 ${styles.subHeader}`}>{bookingData?.price}</p>
            <div className={`${styles.symbolClass} ml-2`}>{`${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
          </div>

          <div className={`d-flex`}>
            <div className={`text-muted`}>Net amount:</div>
            <div className={`${styles.toolTipIconContainer}`}>
              <InfoOutlinedIcon
                fontSize="small"
                color="inherit"
                data-tip
                data-for="netAmount"
                className={styles.toolTipIcon}
              />
              <ReactTooltip
                place="bottom"
                type="dark"
                id="netAmount"
                effect="solid"
                className={styles.toolTip}
              >
                <span>
                  This is the amount remaining after taxes, commissions, and other deductions. <br/>
                  In direct bookings, this is the total due minus taxes. <br/>
                  For channel bookings, it’s the total price minus commission and taxes, depending on the OTA. In multi-rental reservations, it reflects <br/>
                  the combined net payouts. Note: the final host payout may still include taxes collected on behalf of the guest (e.g. city tax).
                </span>
              </ReactTooltip>
            </div>
            <p className={`ml-2 text-muted`}>{editableMode ? "-" : bookingData?.netAmount}</p>
            <div className={`${styles.symbolClass} ml-2`}>{`${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
          </div>

          <div className={`d-flex`}>
            <p>{`Payment status: ${bookingData?.paymentStatus}`}</p>
          </div>

          <div className={`d-flex`}>
            <p className={`mb-0 pb-0 d-flex`}>Show breakdown</p>
            <div className={styles.containerArrowLess}>
                { togglePaymentDropdown ?
                    <ExpandLessIcon
                        className={styles.btnArrowLess}
                        onClick={() => setTogglePaymentDropdown(false)}
                    />
                    :
                    <ExpandMoreIcon
                        className={styles.btnArrowMore}
                        onClick={() => setTogglePaymentDropdown(true)}
                    />
                }
            </div>
          </div>
          { togglePaymentDropdown &&
          <>
          { isChannelBooking &&
            <div className={`mt-2 pt-2 mb-0 pb-0 ml-3`}>

                <div className={`d-flex ${styles.paymentCalcContainer}`}>
                    <div className={styles.subHeader}>
                        { editableMode ? "Original price components (as sent by the OTA)" : "Price components" }
                    </div>
                    <div className={styles.toolTipIconContainer}>
                    <InfoOutlinedIcon
                        fontSize="small"
                        color="inherit"
                        data-tip
                        data-for="priceComponents"
                        className={styles.toolTipIcon}
                    />
                    <ReactTooltip
                        place="bottom"
                        type="dark"
                        id="priceComponents"
                        effect="solid"
                        className={styles.toolTip}
                    >
                        <span>
                            This reservation was imported from an OTA. The price breakdown displays all financial information provided by the channel.
                        </span>
                    </ReactTooltip>
                    </div>
                </div>

                <br />

                <Row className={styles.form_wrapper_for_channel_booking}>
                    <p className={styles.price_label}>Rental price before tax:</p>
                    <div className={styles.price_value}>{`${channelBookingDetails?.totalBeforeTax} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
                </Row>

                <br />

                <Row className={styles.form_wrapper_for_channel_booking}>
                    <p className={`text-muted ${styles.price_label}`}>Rental taxes</p>
                </Row>
                { taxItems.map((item, index) => (
                    <Row key={index} className={styles.form_wrapper_for_channel_booking}>
                        <p className={styles.price_label}>{item.title}</p>
                        <div className={styles.price_value}>{`${item.tax} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
                    </Row>
                ))}
                <Row className={styles.form_wrapper_for_channel_booking}>
                    <p className={styles.price_label}>Total rental taxes:</p>
                    <div className={styles.price_value}>{`${channelBookingDetails?.totalTax} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
                </Row>

                <br />

                <Row className={styles.form_wrapper_for_channel_booking}>
                    <p className={`font-weight-bold ${styles.price_label}`}>Total rental price:</p>
                    <div className={`font-weight-bold ${styles.price_value}`}>{`${bookingData?.price} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
                </Row>

                <br />

                <Row className={styles.form_wrapper_for_channel_booking}>
                    <p className={styles.price_label}>Commission amount:</p>
                    <div className={styles.price_value}>{`${channelBookingDetails?.commissionAmount} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
                </Row>
                <Row className={styles.form_wrapper_for_channel_booking}>
                    <p className={styles.price_label}>Payment charge:</p>
                    <div className={styles.price_value}>{`${channelBookingDetails?.paymentCharge} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
                </Row>

                <br />

                <Row className={styles.form_wrapper_for_channel_booking}>
                    <p className={`text-muted ${styles.price_label}`}>Extra components and fees</p>
                </Row>
                { feeItems.length ?
                    feeItems.map((item, index) => (
                    <Row key={index} className={styles.form_wrapper_for_channel_booking}>
                        <p className={styles.price_label}>{item.title}</p>
                        <div className={styles.price_value}>{`${item.fee} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
                    </Row>
                    ))
                    :
                    <Row className={styles.form_wrapper_for_channel_booking}>
                        <p className={styles.price_label}>No extra components or fees</p>
                    </Row>
                }

                <br />

                <Row className={styles.form_wrapper_for_channel_booking}>
                    <p className={`text-muted ${styles.price_label}`}>Add-ons</p>
                </Row>
                <Row className={styles.form_wrapper_for_channel_booking}>
                    { channelBookingAddonList?.length ?
                        <>
                            <p className={styles.price_label}>Amount:</p>
                            <div className={styles.price_value}>{ channelBookingAddonList?.length }</div>
                        </>
                    :
                        <p className={styles.price_label}>No add-ons</p>
                    }
                </Row>

                <br />

                <Row className={styles.form_wrapper_for_channel_booking}>
                    <p className={`text-muted ${styles.price_label}`}>Taxes</p>
                </Row>
                { otherTaxItems?.length ?
                    otherTaxItems.map((item, index) => (
                    <Row key={index} className={styles.form_wrapper_for_channel_booking}>
                        <p className={styles.price_label}>{item.title}</p>
                        <div className={styles.price_value}>{`${item.tax} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
                    </Row>
                    ))
                    :
                    <Row className={styles.form_wrapper_for_channel_booking}>
                        <p className={styles.price_label}>No taxes</p>
                    </Row>
                }
                
                <br />

                <Row className={styles.form_wrapper_for_channel_booking}>
                    <p className={`text-muted ${styles.price_label}`}>Reservation total</p>
                </Row>
                <Row className={styles.form_wrapper_for_channel_booking}>
                    <p className={styles.price_label}>Total rentals in this reservation:</p>
                    <div className={styles.price_value}>{channelBookingDetails?.numberOfRentals}</div>
                </Row>
                <Row className={styles.form_wrapper_for_channel_booking}>
                    <p className={styles.price_label}>Net amount:</p>
                    <div className={styles.price_value}>{`${channelBookingDetails?.netAmount} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
                </Row>
                <Row className={styles.form_wrapper_for_channel_booking}>
                    <p className={styles.price_label}>Sell amount:</p>
                    <div className={styles.price_value}>{`${channelBookingDetails?.sellAmount} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
                </Row>
                <Row className={styles.form_wrapper_for_channel_booking}>
                    <p className={`font-weight-bold ${styles.price_label}`}>Total price:</p>
                    <div className={`font-weight-bold ${styles.price_value}`}>{`${channelBookingDetails?.totalPrice} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
                </Row>

                <br />

                { channelBookingAddonList?.length ?
                    <>
                        <Row className={styles.form_wrapper}>
                            <p className={`font-weight-bold ${styles.price_label}`}>Add-ons details</p>
                        </Row>
                        <br />
                    </>
                    :
                    <></>
                }

                { channelBookingAddonList?.map((addon, index) => (
                    
                    <div key={index}>
                        <Row className={styles.form_wrapper_for_channel_booking}>
                            <p className={styles.price_label}>Add-on:</p>
                            <div className={styles.price_value}>{addon.name}</div>
                        </Row>
                        <Row className={styles.form_wrapper_for_channel_booking}>
                            <p className={styles.price_label}>Nights:</p>
                            <div className={styles.price_value}>{addon.nights}</div>
                        </Row>
                        <Row className={styles.form_wrapper_for_channel_booking}>
                            <p className={styles.price_label}>Price per unit:</p>
                            <div className={styles.price_value}>{addon.pricePerUnit}</div>
                        </Row>
                        <Row className={styles.form_wrapper_for_channel_booking}>
                            <p className={styles.price_label}>Mode:</p>
                            <div className={styles.price_value}>{mapForPriceMode[addon.priceMode]}</div>
                        </Row>
                        <Row className={styles.form_wrapper_for_channel_booking}>
                            <p className={styles.price_label}>Total:</p>
                            <div className={styles.price_value}>{addon.price}</div>
                        </Row>

                        <Row style={{ marginBottom: '-5px' }} className={styles.form_wrapper}>
                            <p className={`text-muted ${styles.price_label}`}>Taxes included</p>
                        </Row>
                        
                        { addon?.taxes?.map((addonTax, index) => (
                            <Row key={index} className={styles.form_wrapper_for_channel_booking}>
                                <p className={styles.price_label}>{addonTax.name}</p>
                                <div className={styles.price_value}>{addonTax.amount}</div>
                            </Row>
                        ))}
                        
                        <br />

                    </div>
                ))}

            </div>
          }
          { !isChannelBooking &&
          <div className={`mt-2 pt-2 mb-0 pb-0 ml-3`}>

          <div className={`d-flex ${styles.paymentCalcContainer}`}>
            <div className={styles.subHeader}>Payment calculation</div>
            <div className={styles.toolTipIconContainer}>
              <InfoOutlinedIcon
                fontSize="small"
                color="inherit"
                data-tip
                data-for="paymentCalculation"
                className={styles.toolTipIcon}
              />
              <ReactTooltip
                place="bottom"
                type="dark"
                id="paymentCalculation"
                effect="solid"
                className={styles.toolTip}
              >
                <span>
                    Calculations based on your rates settings for this rental.
                    You can change rates, taxes, fees and discounts for this rental by clicking on ‘Rates’ in the top menu.
                </span>
              </ReactTooltip>
            </div>
          </div>

          <Row className={styles.form_wrapper}>
            <div className={`${editableMode ? `text-muted`:``} ${styles.payment_title}`}>Base rate:</div>
            <div className={`${editableMode ? `text-muted`:``} ${styles.payment_data}`}>{editableMode ? '-'  : `${baseRate} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
          </Row>
          <Row className={styles.form_wrapper}>
            <div className={`${editableMode ? `text-muted`:``} ${styles.payment_title}`}>Extra guest fee:</div>
            <div className={`${editableMode ? `text-muted`:``} ${styles.payment_data}`}>{editableMode ? '-'  : `${extraGuestFee} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
          </Row>
          <Row className={styles.form_wrapper}>
            <div className={`${editableMode ? `text-muted`:``} ${styles.payment_title}`}>Total rent: </div>
            <div className={`${editableMode ? `text-muted`:``} ${styles.payment_data}`}>{editableMode ? '-'  : `${baseRate+extraGuestFee} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
          </Row>
          <Row className={styles.form_wrapper}>
            <div className={`${editableMode ? `text-muted`:``} ${styles.payment_title}`}>Discount:</div>
            <div className={`${editableMode ? `text-muted`:``} ${styles.payment_data}`}>{editableMode ? '-'  : `${discount.amount ? -discount.amount : 0} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
          </Row>
          <Row className={styles.form_wrapper}>
            <div className={`${editableMode ? `text-muted`:``} ${styles.payment_title}`}>Extra charge: </div>
            <div className={`${editableMode ? `text-muted`:``} ${styles.payment_data}`}>{editableMode ? '-'  : `${charges.amount || 0} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
          </Row>
          <Row className={styles.form_wrapper}>
            <div className={`${editableMode ? `text-muted`:``} ${styles.payment_title}`}>Fees:</div>
            <div className={`${editableMode ? `text-muted`:``} ${styles.payment_data}`}>{editableMode ? '-'  : `${fee} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
          </Row>
          <Row className={styles.form_wrapper}>
            <div className={`${editableMode ? `text-muted`:``} ${styles.payment_title}`}>Taxes: </div>
            <div className={`${editableMode ? `text-muted`:``} ${styles.payment_data}`}>{editableMode ? '-'  : `${tax} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
          </Row>

          <Row className={`mt-2 pt-2 mb-0 pb-0 ${styles.form_wrapper}`}>
            <div className={`${editableMode ? `text-muted`:``} ${styles.payment_title} ${styles.subHeader}`}>Total due:</div>
            <div className={`${editableMode ? `text-muted`:``} ${styles.payment_data} ${styles.subHeader}`}>{editableMode ? '-'  : `${bookingData?.price} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
          </Row>
          <Row className={`mt-0 pt-0 ${styles.form_wrapper}`}>
            <div className={`${styles.payment_title} text-muted`}>Net amount:</div>
            <div className={`${styles.payment_data} text-muted`}>{editableMode ? '-'  : `${bookingData?.netAmount} ${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
          </Row>

          </div>
          }
          </>
          }
          
          <hr />

          <div className={`d-flex`}>
            <p className={styles.subHeader}>Discount and extra charges</p>
          </div>

          { isChannelBooking || editableMode ?
          <p className={`${styles.discount_and_extra_charges_description}`}>
            { isChannelBooking ?
                'Discounts or extras charges can’t be added to channel reservations.'
                :
                'Discounts or extras charges can’t be added to reservations that use the "New total" feature.'
            }
          </p>
          :
          <>
          <div className={`mb-2 d-flex align-items-center`}>
            <FormBS.Check
              type="checkbox"
              id="discountCheckbox"
              name="discountCheckbox"
              checked={values?.discountCheckbox}
              onChange={() => {
                const discountCheckbox = getCheckboxValue(values?.discountCheckbox);
                setFieldValue("discountCheckbox", discountCheckbox);
              }}
              className={`my-0 py-0`}
            />
            <p className={`my-0 py-0`}>Add discount</p>
          </div>
          { values?.discountCheckbox &&
          <>
          <div className={`my-0 py-0 d-flex align-items-center ${styles.form_wrapper}`}>
            <div className={`${editableMode?`text-muted`:``} ${styles.payment_title_sm}`}>Name:</div>
              {editableMode ?
                '-'
              :
              <input
                type={'text'}
                className={styles.payment_entry_sm}
                value={discount.name}
                onChange={(e) => {
                  const targetValue = {...discount, name: e.target.value};
                  setDiscount(targetValue);
                  setFieldValue('discountName', e.target.value);
                }}
              />
              }
          </div>
          <div className={`${styles.errorMessage}`} >{errors.discountName}</div>

          <div className={`my-0 py-0 d-flex align-items-center ${styles.form_wrapper}`}>
            <div className={`${editableMode?`text-muted`:``} ${styles.payment_title_sm}`}>Amount:</div>
              {editableMode ?
                  '-'
                :
              <>
              <div>
              <input
                    type="text"
                    name="discount"
                    className={styles.payment_entry_amount}
                    value={discount.amount ? discount.amount : ''}
                    placeholder={0}
                    onChange={(e) => {
                      handleChange(e);
                      setFieldValue('discountAmount', e.target.value);
                    }}
                />
                <div className={styles.customError}>
                  {errorDisc?errorDisc:""}
                </div>
              </div>
              <div className={`${editableMode?`text-muted`:``} ${styles.symbolClass} ml-2`}>{`${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
              </>
              }
          </div>
          <div className={`${styles.errorMessage}`} >{errors.discountAmount}</div>
          </>
          }

          <div className={`mb-2 d-flex align-items-center`}>
            <FormBS.Check
              type="checkbox"
              id="chargetCheckbox"
              name="chargetCheckbox"
              checked={values?.chargetCheckbox}
              onChange={() => {
                const chargetCheckbox = getCheckboxValue(values?.chargetCheckbox);
                setFieldValue("chargetCheckbox", chargetCheckbox);
              }}
              className={`my-0 py-0`}
            />
            <p className={`my-0 py-0`}>Add extra charge</p>
          </div>
          { values?.chargetCheckbox &&
          <>
          <div className={`my-0 py-0 d-flex align-items-center ${styles.form_wrapper}`}>
            <div className={`${editableMode?`text-muted`:``} ${styles.payment_title_sm}`}>Name:</div>
            {editableMode ?
              '-'
            :
            <input
                type={'text'}
                className={styles.payment_entry_sm}
                value={charges.name}
                onChange={(e) => {
                  const targetValue = {...charges, name: e.target.value};
                  setCharges(targetValue);
                  setFieldValue('chargeName', e.target.value);
                }}
                />
              }
          </div>
          <div className={`${styles.errorMessage}`} >{errors.chargeName}</div>

          <div className={`my-0 py-0 d-flex align-items-center ${styles.form_wrapper}`}>
            <div className={`${editableMode?`text-muted`:``} ${styles.payment_title_sm}`}>Amount:</div>
            {editableMode ?
                '-'
              :
              <>
              <input
                type="text"
                name="charges"
                className={styles.payment_entry_amount}
                value={charges.amount ? charges.amount : ''}
                placeholder={0}
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue('chargeAmount', e.target.value);
                }}
                />
              <div className={`${editableMode?`text-muted`:``} ${styles.symbolClass} ml-2`}>{`${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
            </>
            }
          </div>
          <div className={`${styles.errorMessage}`} >{errors.chargeAmount}</div>
          </>
          }
          </>
          }

          <hr />

          <div className={`pb-2 d-flex ${styles.withToggle}`}>
            <div className={`d-flex flex-direction-row`}>
              <div className={styles.subHeader}>Overwrite total due </div>
              <div className={styles.toolTipIconContainer}>
                <InfoOutlinedIcon
                    fontSize="small"
                    color="inherit"
                    data-tip
                    data-for="overWrite"
                    className={styles.toolTipIcon}
                />
                <ReactTooltip place="top" type="dark" id="overWrite" effect="solid" className={styles.toolTip}>
                <span>
                  Overwrite the total due for this reservation. Doing this will erase the system payment
                  calculation and any charges or discounts you set for this booking. This will become the total
                  amount due for this booking.<br/>
                  If you set this amount to 0, the system’s payment calculations will be used again, along with
                  charges or discounts you set above. If you intend not to charge for this booking, set the
                  discount amount equal to the total rent.
                </span>
                </ReactTooltip>
              </div>
            </div>
          </div>
          <div className={`mt-2 d-flex flex-direction-column ${styles.withToggle}`}>
            <p className="mr-2">Set new price</p>
            <Toggle
                icons={false}
                id={"overWriteToggle"}
                checked={editableMode}
                onChange={() => {
                  setEditableMode(!editableMode);
                  resetForm();
                  setDiscount({ name: values.discountName, amount: values.discountAmount });
                  setCharges({ name: values.chargeName, amount: values.chargeAmount });
                  setOverWrite(values.overWrittenTotal);
                }}
            />
          </div>
          <div className={`d-flex align-items-center ${styles.form_wrapper}`}>
            <p className="m-0 p-0 mr-2 mb-1">New total: </p>
            <input
              type="text"
              name="overWrittenTotal"
              className={styles.payment_entry_amount}
              value={editableMode ? (overWrittenTotal || '') : newTotal}
              placeholder={0}
              onChange={(e) => {
                handleChange(e);
                setFieldValue('overWrittenTotal', e.target.value);
              }}
              disabled={!editableMode}
            />
            <div className={`${styles.symbolClass} ml-2`}>{`${getSymbolFromCurrency(rentalDetail.currency)}`}</div>
          </div>
          <div className={`${styles.errorMessage}`} >{errors.overWrittenTotal}</div>

      </>

      {(!isChannelBooking || editableMode) &&
      <div className={`d-flex justify-content-center ${styles.button_group}`}>
        <div>
          <button className={styles.settings_save} type="submit" disabled={errorDisc}>
            Save Changes
          </button>
        </div>
      </div>
      }

      </Form>
      )}
      </Formik>
    </div>
  );
};

export default Payment;